import {useState} from "react";
import './theme.scss';
import {ReactComponent as Moon} from '../../Assets/Svg/moon-stars.svg';
import {ReactComponent as Sun} from '../../Assets/Svg/sun.svg';
import { playMenuOver,playSwitchOff,playSwitchOn } from "../../Sounds/Sounds";


const Theme = () =>{
    const [currentTheme, setCurrentTheme] = useState<string>(localStorage.getItem("theme") || "dark");
   

    const changeTheme = () => {
        if(currentTheme === "light"){
            playSwitchOn();
        }
        else{
            playSwitchOff();
        }
        setCurrentTheme(currentTheme === "light" ? "dark" : "light")
        localStorage.setItem("theme",currentTheme === "light" ? "dark" : "light");
        document.body.className = `${currentTheme === "light" ? "dark" : "light"}-theme`;
    }

    return(
        <div className="theme" onClick={changeTheme} onMouseEnter={() => {playMenuOver()}}>
            <Sun style={{opacity: currentTheme === "light" ? 1 : 0}}/>
            <Moon style={{opacity: currentTheme === "dark" ? 1 : 0}}/>
        </div>
    )
}
export default Theme